























import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";

@Component
export default class TooltipButton extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: "" }) disabledTooltipText!: string;
  @Prop({ default: "" }) tooltipText!: string;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) icon!: string;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: true }) outlined!: boolean;
  @Prop({ default: "ma-2" }) buttonClass!: string;
}
